import { Fragment } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "./Alert";
import React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const SnackAlert = ({ handler, ...props }) => {
  const { alert, closeAlert } = handler;
  const { action, duration } = props;

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={alert.open}
      autoHideDuration={duration ?? 6000}
      onClose={() => closeAlert()}
    >
      <Alert
        onClose={() => closeAlert()}
        severity={alert.severity}
        action={
          <Fragment>
            {alert.showAction && action}
            <IconButton
              size="small"
              style={{ color: "white" }}
              onClick={() => closeAlert()}
            >
              <CloseIcon />
            </IconButton>
          </Fragment>
        }
      >
        {alert.messages &&
          alert.messages.map((message, idx) => (
            <div key={idx}>{message}</div>
          ))}
      </Alert>
    </Snackbar>
  );
};

export default SnackAlert;
